export default "__VITE_ASSET__DvyEbzZP__"